import { createSelector } from 'reselect'
import { getCurrentSiteId } from 'modules/sites/selectors'

export const getSchedulesState = state => state.schedules
export const getSchedules = createSelector(
  getSchedulesState,
  schedules => schedules.list
)
export const getCurrentSiteSchedule = createSelector(
  getCurrentSiteId,
  getSchedules,
  (siteId, schedules) => {
    return schedules.find(({ site }) => site === siteId)
  }
)



// WEBPACK FOOTER //
// ./src/modules/schedules/selectors.js